// source: accounts/protos/pangolin.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var accounts_protos_pangolin_dto_pb = require('../../accounts/protos/pangolin_dto_pb.js');
goog.object.extend(proto, accounts_protos_pangolin_dto_pb);
goog.exportSymbol('proto.accounts.protos.ClaimPangolinRequest', null, global);
goog.exportSymbol('proto.accounts.protos.ClaimPangolinRequest.RegistrationDataCase', null, global);
goog.exportSymbol('proto.accounts.protos.ClaimPangolinResponse', null, global);
goog.exportSymbol('proto.accounts.protos.ClaimPangolinResponse.RegistrationDataCase', null, global);
goog.exportSymbol('proto.accounts.protos.GenericPangolinResponse', null, global);
goog.exportSymbol('proto.accounts.protos.PangolinSupportCheckRequest', null, global);
goog.exportSymbol('proto.accounts.protos.PangolinSupportEnableRequest', null, global);
goog.exportSymbol('proto.accounts.protos.UnclaimPangolinRequest', null, global);
goog.exportSymbol('proto.accounts.protos.UnclaimPangolinResponse', null, global);
goog.exportSymbol('proto.accounts.protos.UpdatePangolinRequest', null, global);
goog.exportSymbol('proto.accounts.protos.UpdatePangolinResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.ClaimPangolinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_);
};
goog.inherits(proto.accounts.protos.ClaimPangolinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.ClaimPangolinRequest.displayName = 'proto.accounts.protos.ClaimPangolinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.ClaimPangolinResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_);
};
goog.inherits(proto.accounts.protos.ClaimPangolinResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.ClaimPangolinResponse.displayName = 'proto.accounts.protos.ClaimPangolinResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.UnclaimPangolinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.UnclaimPangolinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.UnclaimPangolinRequest.displayName = 'proto.accounts.protos.UnclaimPangolinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.UnclaimPangolinResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.UnclaimPangolinResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.UnclaimPangolinResponse.displayName = 'proto.accounts.protos.UnclaimPangolinResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.UpdatePangolinRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.UpdatePangolinRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.UpdatePangolinRequest.displayName = 'proto.accounts.protos.UpdatePangolinRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.UpdatePangolinResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.UpdatePangolinResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.UpdatePangolinResponse.displayName = 'proto.accounts.protos.UpdatePangolinResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.PangolinSupportCheckRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.PangolinSupportCheckRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.PangolinSupportCheckRequest.displayName = 'proto.accounts.protos.PangolinSupportCheckRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.PangolinSupportEnableRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accounts.protos.PangolinSupportEnableRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.PangolinSupportEnableRequest.displayName = 'proto.accounts.protos.PangolinSupportEnableRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accounts.protos.GenericPangolinResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accounts.protos.GenericPangolinResponse.repeatedFields_, null);
};
goog.inherits(proto.accounts.protos.GenericPangolinResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accounts.protos.GenericPangolinResponse.displayName = 'proto.accounts.protos.GenericPangolinResponse';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.accounts.protos.ClaimPangolinRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.accounts.protos.ClaimPangolinRequest.RegistrationDataCase = {
  REGISTRATION_DATA_NOT_SET: 0,
  REGISTRATION_NONCE: 2,
  REGISTRATION_NONCE_MNEMONIC: 3
};

/**
 * @return {proto.accounts.protos.ClaimPangolinRequest.RegistrationDataCase}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.getRegistrationDataCase = function() {
  return /** @type {proto.accounts.protos.ClaimPangolinRequest.RegistrationDataCase} */(jspb.Message.computeOneofCase(this, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.ClaimPangolinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.ClaimPangolinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.ClaimPangolinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    registrationNonce: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    registrationNonceMnemonic: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.ClaimPangolinRequest}
 */
proto.accounts.protos.ClaimPangolinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.ClaimPangolinRequest;
  return proto.accounts.protos.ClaimPangolinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.ClaimPangolinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.ClaimPangolinRequest}
 */
proto.accounts.protos.ClaimPangolinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationNonce(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationNonceMnemonic(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.ClaimPangolinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.ClaimPangolinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.ClaimPangolinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string registration_nonce = 2;
 * @return {string}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.getRegistrationNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.ClaimPangolinRequest} returns this
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.setRegistrationNonce = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinRequest} returns this
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.clearRegistrationNonce = function() {
  return jspb.Message.setOneofField(this, 2, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.hasRegistrationNonce = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string registration_nonce_mnemonic = 3;
 * @return {string}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.getRegistrationNonceMnemonic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.ClaimPangolinRequest} returns this
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.setRegistrationNonceMnemonic = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinRequest} returns this
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.clearRegistrationNonceMnemonic = function() {
  return jspb.Message.setOneofField(this, 3, proto.accounts.protos.ClaimPangolinRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinRequest.prototype.hasRegistrationNonceMnemonic = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.accounts.protos.ClaimPangolinResponse.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.accounts.protos.ClaimPangolinResponse.RegistrationDataCase = {
  REGISTRATION_DATA_NOT_SET: 0,
  REGISTRATION_NONCE_ERROR: 3,
  REGISTRATION_NONCE_MNEMONIC_ERROR: 4
};

/**
 * @return {proto.accounts.protos.ClaimPangolinResponse.RegistrationDataCase}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.getRegistrationDataCase = function() {
  return /** @type {proto.accounts.protos.ClaimPangolinResponse.RegistrationDataCase} */(jspb.Message.computeOneofCase(this, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.ClaimPangolinResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.ClaimPangolinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.ClaimPangolinResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    pangolin: (f = msg.getPangolin()) && accounts_protos_pangolin_dto_pb.PangolinDTO.toObject(includeInstance, f),
    registrationNonceError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    registrationNonceMnemonicError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.ClaimPangolinResponse}
 */
proto.accounts.protos.ClaimPangolinResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.ClaimPangolinResponse;
  return proto.accounts.protos.ClaimPangolinResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.ClaimPangolinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.ClaimPangolinResponse}
 */
proto.accounts.protos.ClaimPangolinResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_pangolin_dto_pb.PangolinDTO;
      reader.readMessage(value,accounts_protos_pangolin_dto_pb.PangolinDTO.deserializeBinaryFromReader);
      msg.setPangolin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationNonceError(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationNonceMnemonicError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.ClaimPangolinResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.ClaimPangolinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.ClaimPangolinResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPangolin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_pangolin_dto_pb.PangolinDTO.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PangolinDTO pangolin = 2;
 * @return {?proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.getPangolin = function() {
  return /** @type{?proto.accounts.protos.PangolinDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_pangolin_dto_pb.PangolinDTO, 2));
};


/**
 * @param {?proto.accounts.protos.PangolinDTO|undefined} value
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
*/
proto.accounts.protos.ClaimPangolinResponse.prototype.setPangolin = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.clearPangolin = function() {
  return this.setPangolin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.hasPangolin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string registration_nonce_error = 3;
 * @return {string}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.getRegistrationNonceError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.setRegistrationNonceError = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.clearRegistrationNonceError = function() {
  return jspb.Message.setOneofField(this, 3, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.hasRegistrationNonceError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string registration_nonce_mnemonic_error = 4;
 * @return {string}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.getRegistrationNonceMnemonicError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.setRegistrationNonceMnemonicError = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.ClaimPangolinResponse} returns this
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.clearRegistrationNonceMnemonicError = function() {
  return jspb.Message.setOneofField(this, 4, proto.accounts.protos.ClaimPangolinResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.ClaimPangolinResponse.prototype.hasRegistrationNonceMnemonicError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.UnclaimPangolinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.UnclaimPangolinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UnclaimPangolinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    password: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.UnclaimPangolinRequest}
 */
proto.accounts.protos.UnclaimPangolinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.UnclaimPangolinRequest;
  return proto.accounts.protos.UnclaimPangolinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.UnclaimPangolinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.UnclaimPangolinRequest}
 */
proto.accounts.protos.UnclaimPangolinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.UnclaimPangolinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.UnclaimPangolinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UnclaimPangolinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinRequest} returns this
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinRequest} returns this
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinRequest} returns this
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinRequest} returns this
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.UnclaimPangolinResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.UnclaimPangolinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UnclaimPangolinResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    idError: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    passwordError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    updateUpgradeError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    updateRestoreError: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    planFirewallSubscriptionError: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse}
 */
proto.accounts.protos.UnclaimPangolinResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.UnclaimPangolinResponse;
  return proto.accounts.protos.UnclaimPangolinResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.UnclaimPangolinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse}
 */
proto.accounts.protos.UnclaimPangolinResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdError(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPasswordError(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateUpgradeError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateRestoreError(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanFirewallSubscriptionError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.UnclaimPangolinResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.UnclaimPangolinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UnclaimPangolinResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string id_error = 2;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getIdError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setIdError = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearIdError = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasIdError = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string password_error = 3;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getPasswordError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setPasswordError = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearPasswordError = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasPasswordError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string update_upgrade_error = 4;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getUpdateUpgradeError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setUpdateUpgradeError = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearUpdateUpgradeError = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasUpdateUpgradeError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string update_restore_error = 5;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getUpdateRestoreError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setUpdateRestoreError = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearUpdateRestoreError = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasUpdateRestoreError = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string plan_firewall_subscription_error = 6;
 * @return {string}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.getPlanFirewallSubscriptionError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.setPlanFirewallSubscriptionError = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UnclaimPangolinResponse} returns this
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.clearPlanFirewallSubscriptionError = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UnclaimPangolinResponse.prototype.hasPlanFirewallSubscriptionError = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.UpdatePangolinRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.UpdatePangolinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UpdatePangolinRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    nickname: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    colorCode: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    timezone: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    bandwidthUploadString: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    bandwidthUploadUnits: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    bandwidthDownloadString: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    bandwidthDownloadUnits: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    enableBandwidthControls: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
    enableBufferbloatPrevention: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f,
    menderPendingUpdatePopupDisplay: (f = jspb.Message.getBooleanField(msg, 11)) == null ? undefined : f,
    redirectModeBridgeEnabled: (f = jspb.Message.getBooleanField(msg, 29)) == null ? undefined : f,
    redirectModeUnicastEnabled: (f = jspb.Message.getBooleanField(msg, 12)) == null ? undefined : f,
    redirectModeUnicastTypeResponse: (f = jspb.Message.getBooleanField(msg, 13)) == null ? undefined : f,
    redirectModeUnicastTypeRequest: (f = jspb.Message.getBooleanField(msg, 14)) == null ? undefined : f,
    redirectModeUnicastNetworkInternet: (f = jspb.Message.getBooleanField(msg, 27)) == null ? undefined : f,
    redirectModeUnicastNetworkInternal: (f = jspb.Message.getBooleanField(msg, 28)) == null ? undefined : f,
    redirectModeBroadcastEnabled: (f = jspb.Message.getBooleanField(msg, 15)) == null ? undefined : f,
    redirectModeBroadcastHostGateways: (f = jspb.Message.getBooleanField(msg, 16)) == null ? undefined : f,
    redirectModeBroadcastHostHosts: (f = jspb.Message.getBooleanField(msg, 17)) == null ? undefined : f,
    redirectModeBroadcastHostAll: (f = jspb.Message.getBooleanField(msg, 18)) == null ? undefined : f,
    redirectModeBroadcastTypeResponse: (f = jspb.Message.getBooleanField(msg, 19)) == null ? undefined : f,
    redirectModeBroadcastTypeRequest: (f = jspb.Message.getBooleanField(msg, 20)) == null ? undefined : f,
    masqueradeEgress: (f = jspb.Message.getBooleanField(msg, 21)) == null ? undefined : f,
    scannerEnableScanMdns: (f = jspb.Message.getBooleanField(msg, 22)) == null ? undefined : f,
    scannerEnableScanNbios: (f = jspb.Message.getBooleanField(msg, 23)) == null ? undefined : f,
    scannerEnableScanNmap: (f = jspb.Message.getBooleanField(msg, 24)) == null ? undefined : f,
    scannerEnableScanRdns: (f = jspb.Message.getBooleanField(msg, 25)) == null ? undefined : f,
    scannerEnableScanUpnp: (f = jspb.Message.getBooleanField(msg, 26)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.UpdatePangolinRequest}
 */
proto.accounts.protos.UpdatePangolinRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.UpdatePangolinRequest;
  return proto.accounts.protos.UpdatePangolinRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.UpdatePangolinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.UpdatePangolinRequest}
 */
proto.accounts.protos.UpdatePangolinRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 3:
      var value = /** @type {!proto.accounts.protos.ColorCode} */ (reader.readEnum());
      msg.setColorCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadString(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadUnits(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadString(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadUnits(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBandwidthControls(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableBufferbloatPrevention(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMenderPendingUpdatePopupDisplay(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBridgeEnabled(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastEnabled(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeResponse(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeRequest(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternet(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternal(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastEnabled(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostGateways(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostHosts(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostAll(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeResponse(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeRequest(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMasqueradeEgress(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanMdns(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNbios(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNmap(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanRdns(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanUpnp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.UpdatePangolinRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.UpdatePangolinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UpdatePangolinRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {!proto.accounts.protos.ColorCode} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeBool(
      29,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeBool(
      14,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeBool(
      27,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeBool(
      28,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeBool(
      15,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeBool(
      19,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeBool(
      20,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeBool(
      21,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeBool(
      22,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeBool(
      23,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeBool(
      24,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeBool(
      25,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeBool(
      26,
      f
    );
  }
};


/**
 * required string id = 1;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string nickname = 2;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setNickname = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearNickname = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasNickname = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ColorCode color_code = 3;
 * @return {!proto.accounts.protos.ColorCode}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getColorCode = function() {
  return /** @type {!proto.accounts.protos.ColorCode} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.accounts.protos.ColorCode} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setColorCode = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearColorCode = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasColorCode = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string timezone = 4;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setTimezone = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearTimezone = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasTimezone = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string bandwidth_upload_string = 5;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getBandwidthUploadString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setBandwidthUploadString = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearBandwidthUploadString = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasBandwidthUploadString = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string bandwidth_upload_units = 6;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getBandwidthUploadUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setBandwidthUploadUnits = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearBandwidthUploadUnits = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasBandwidthUploadUnits = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string bandwidth_download_string = 7;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getBandwidthDownloadString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setBandwidthDownloadString = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearBandwidthDownloadString = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasBandwidthDownloadString = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string bandwidth_download_units = 8;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getBandwidthDownloadUnits = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setBandwidthDownloadUnits = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearBandwidthDownloadUnits = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasBandwidthDownloadUnits = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool enable_bandwidth_controls = 9;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getEnableBandwidthControls = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setEnableBandwidthControls = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearEnableBandwidthControls = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasEnableBandwidthControls = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool enable_bufferbloat_prevention = 10;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getEnableBufferbloatPrevention = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setEnableBufferbloatPrevention = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearEnableBufferbloatPrevention = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasEnableBufferbloatPrevention = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool mender_pending_update_popup_display = 11;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getMenderPendingUpdatePopupDisplay = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setMenderPendingUpdatePopupDisplay = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearMenderPendingUpdatePopupDisplay = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasMenderPendingUpdatePopupDisplay = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool redirect_mode_bridge_enabled = 29;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBridgeEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBridgeEnabled = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBridgeEnabled = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBridgeEnabled = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional bool redirect_mode_unicast_enabled = 12;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeUnicastEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeUnicastEnabled = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeUnicastEnabled = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeUnicastEnabled = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool redirect_mode_unicast_type_response = 13;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeUnicastTypeResponse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeUnicastTypeResponse = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeUnicastTypeResponse = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeUnicastTypeResponse = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool redirect_mode_unicast_type_request = 14;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeUnicastTypeRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeUnicastTypeRequest = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeUnicastTypeRequest = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeUnicastTypeRequest = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internet = 27;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeUnicastNetworkInternet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeUnicastNetworkInternet = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeUnicastNetworkInternet = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeUnicastNetworkInternet = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internal = 28;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeUnicastNetworkInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeUnicastNetworkInternal = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeUnicastNetworkInternal = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeUnicastNetworkInternal = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional bool redirect_mode_broadcast_enabled = 15;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastEnabled = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastEnabled = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastEnabled = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_gateways = 16;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastHostGateways = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastHostGateways = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastHostGateways = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastHostGateways = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_hosts = 17;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastHostHosts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastHostHosts = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastHostHosts = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastHostHosts = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_all = 18;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastHostAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastHostAll = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastHostAll = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastHostAll = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_response = 19;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastTypeResponse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastTypeResponse = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastTypeResponse = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastTypeResponse = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_request = 20;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getRedirectModeBroadcastTypeRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setRedirectModeBroadcastTypeRequest = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearRedirectModeBroadcastTypeRequest = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasRedirectModeBroadcastTypeRequest = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional bool masquerade_egress = 21;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getMasqueradeEgress = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setMasqueradeEgress = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearMasqueradeEgress = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasMasqueradeEgress = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool scanner_enable_scan_mdns = 22;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getScannerEnableScanMdns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setScannerEnableScanMdns = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearScannerEnableScanMdns = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasScannerEnableScanMdns = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool scanner_enable_scan_nbios = 23;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getScannerEnableScanNbios = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setScannerEnableScanNbios = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearScannerEnableScanNbios = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasScannerEnableScanNbios = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool scanner_enable_scan_nmap = 24;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getScannerEnableScanNmap = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setScannerEnableScanNmap = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearScannerEnableScanNmap = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasScannerEnableScanNmap = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool scanner_enable_scan_rdns = 25;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getScannerEnableScanRdns = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setScannerEnableScanRdns = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearScannerEnableScanRdns = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasScannerEnableScanRdns = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool scanner_enable_scan_upnp = 26;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.getScannerEnableScanUpnp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.setScannerEnableScanUpnp = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinRequest} returns this
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.clearScannerEnableScanUpnp = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinRequest.prototype.hasScannerEnableScanUpnp = function() {
  return jspb.Message.getField(this, 26) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.UpdatePangolinResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.UpdatePangolinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UpdatePangolinResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    pangolin: (f = msg.getPangolin()) && accounts_protos_pangolin_dto_pb.PangolinDTO.toObject(includeInstance, f),
    idError: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    nicknameError: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    colorCodeError: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    timezoneError: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    bandwidthUploadStringError: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    bandwidthUploadUnitsError: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    bandwidthDownloadStringError: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    bandwidthDownloadUnitsError: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    enableBandwidthControlsError: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    enableBufferbloatPreventionError: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    redirectModeBridgeEnabledError: (f = jspb.Message.getBooleanField(msg, 30)) == null ? undefined : f,
    redirectModeUnicastEnabledError: (f = jspb.Message.getBooleanField(msg, 13)) == null ? undefined : f,
    redirectModeUnicastTypeResponseError: (f = jspb.Message.getBooleanField(msg, 14)) == null ? undefined : f,
    redirectModeUnicastTypeRequestError: (f = jspb.Message.getBooleanField(msg, 15)) == null ? undefined : f,
    redirectModeUnicastNetworkInternetError: (f = jspb.Message.getBooleanField(msg, 28)) == null ? undefined : f,
    redirectModeUnicastNetworkInternalError: (f = jspb.Message.getBooleanField(msg, 29)) == null ? undefined : f,
    redirectModeBroadcastEnabledError: (f = jspb.Message.getBooleanField(msg, 16)) == null ? undefined : f,
    redirectModeBroadcastHostGatewaysError: (f = jspb.Message.getBooleanField(msg, 17)) == null ? undefined : f,
    redirectModeBroadcastHostHostsError: (f = jspb.Message.getBooleanField(msg, 18)) == null ? undefined : f,
    redirectModeBroadcastHostAllError: (f = jspb.Message.getBooleanField(msg, 19)) == null ? undefined : f,
    redirectModeBroadcastTypeResponseError: (f = jspb.Message.getBooleanField(msg, 20)) == null ? undefined : f,
    redirectModeBroadcastTypeRequestError: (f = jspb.Message.getBooleanField(msg, 21)) == null ? undefined : f,
    masqueradeEgressError: (f = jspb.Message.getBooleanField(msg, 22)) == null ? undefined : f,
    scannerEnableScanMdnsError: (f = jspb.Message.getBooleanField(msg, 23)) == null ? undefined : f,
    scannerEnableScanNbiosError: (f = jspb.Message.getBooleanField(msg, 24)) == null ? undefined : f,
    scannerEnableScanNmapError: (f = jspb.Message.getBooleanField(msg, 25)) == null ? undefined : f,
    scannerEnableScanRdnsError: (f = jspb.Message.getBooleanField(msg, 26)) == null ? undefined : f,
    scannerEnableScanUpnpError: (f = jspb.Message.getBooleanField(msg, 27)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.UpdatePangolinResponse}
 */
proto.accounts.protos.UpdatePangolinResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.UpdatePangolinResponse;
  return proto.accounts.protos.UpdatePangolinResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.UpdatePangolinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.UpdatePangolinResponse}
 */
proto.accounts.protos.UpdatePangolinResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_pangolin_dto_pb.PangolinDTO;
      reader.readMessage(value,accounts_protos_pangolin_dto_pb.PangolinDTO.deserializeBinaryFromReader);
      msg.setPangolin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdError(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNicknameError(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColorCodeError(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezoneError(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadStringError(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthUploadUnitsError(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadStringError(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBandwidthDownloadUnitsError(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnableBandwidthControlsError(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnableBufferbloatPreventionError(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBridgeEnabledError(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastEnabledError(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeResponseError(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastTypeRequestError(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternetError(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeUnicastNetworkInternalError(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastEnabledError(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostGatewaysError(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostHostsError(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastHostAllError(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeResponseError(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedirectModeBroadcastTypeRequestError(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMasqueradeEgressError(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanMdnsError(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNbiosError(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanNmapError(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanRdnsError(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setScannerEnableScanUpnpError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.UpdatePangolinResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.UpdatePangolinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.UpdatePangolinResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPangolin();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      accounts_protos_pangolin_dto_pb.PangolinDTO.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 30));
  if (f != null) {
    writer.writeBool(
      30,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeBool(
      14,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeBool(
      15,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeBool(
      28,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeBool(
      29,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeBool(
      19,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeBool(
      20,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeBool(
      21,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeBool(
      22,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeBool(
      23,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeBool(
      24,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeBool(
      25,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeBool(
      26,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeBool(
      27,
      f
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PangolinDTO pangolin = 2;
 * @return {?proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getPangolin = function() {
  return /** @type{?proto.accounts.protos.PangolinDTO} */ (
    jspb.Message.getWrapperField(this, accounts_protos_pangolin_dto_pb.PangolinDTO, 2));
};


/**
 * @param {?proto.accounts.protos.PangolinDTO|undefined} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
*/
proto.accounts.protos.UpdatePangolinResponse.prototype.setPangolin = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearPangolin = function() {
  return this.setPangolin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasPangolin = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string id_error = 3;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getIdError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setIdError = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearIdError = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasIdError = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string nickname_error = 4;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getNicknameError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setNicknameError = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearNicknameError = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasNicknameError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string color_code_error = 5;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getColorCodeError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setColorCodeError = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearColorCodeError = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasColorCodeError = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string timezone_error = 6;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getTimezoneError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setTimezoneError = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearTimezoneError = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasTimezoneError = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string bandwidth_upload_string_error = 7;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getBandwidthUploadStringError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setBandwidthUploadStringError = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearBandwidthUploadStringError = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasBandwidthUploadStringError = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string bandwidth_upload_units_error = 8;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getBandwidthUploadUnitsError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setBandwidthUploadUnitsError = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearBandwidthUploadUnitsError = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasBandwidthUploadUnitsError = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string bandwidth_download_string_error = 9;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getBandwidthDownloadStringError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setBandwidthDownloadStringError = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearBandwidthDownloadStringError = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasBandwidthDownloadStringError = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string bandwidth_download_units_error = 10;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getBandwidthDownloadUnitsError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setBandwidthDownloadUnitsError = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearBandwidthDownloadUnitsError = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasBandwidthDownloadUnitsError = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string enable_bandwidth_controls_error = 11;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getEnableBandwidthControlsError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setEnableBandwidthControlsError = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearEnableBandwidthControlsError = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasEnableBandwidthControlsError = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string enable_bufferbloat_prevention_error = 12;
 * @return {string}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getEnableBufferbloatPreventionError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setEnableBufferbloatPreventionError = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearEnableBufferbloatPreventionError = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasEnableBufferbloatPreventionError = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool redirect_mode_bridge_enabled_error = 30;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBridgeEnabledError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBridgeEnabledError = function(value) {
  return jspb.Message.setField(this, 30, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBridgeEnabledError = function() {
  return jspb.Message.setField(this, 30, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBridgeEnabledError = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional bool redirect_mode_unicast_enabled_error = 13;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeUnicastEnabledError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeUnicastEnabledError = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeUnicastEnabledError = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeUnicastEnabledError = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool redirect_mode_unicast_type_response_error = 14;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeUnicastTypeResponseError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeUnicastTypeResponseError = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeUnicastTypeResponseError = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeUnicastTypeResponseError = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool redirect_mode_unicast_type_request_error = 15;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeUnicastTypeRequestError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeUnicastTypeRequestError = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeUnicastTypeRequestError = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeUnicastTypeRequestError = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internet_error = 28;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeUnicastNetworkInternetError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeUnicastNetworkInternetError = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeUnicastNetworkInternetError = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeUnicastNetworkInternetError = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional bool redirect_mode_unicast_network_internal_error = 29;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeUnicastNetworkInternalError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeUnicastNetworkInternalError = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeUnicastNetworkInternalError = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeUnicastNetworkInternalError = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional bool redirect_mode_broadcast_enabled_error = 16;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastEnabledError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastEnabledError = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastEnabledError = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastEnabledError = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_gateways_error = 17;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastHostGatewaysError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastHostGatewaysError = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastHostGatewaysError = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastHostGatewaysError = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_hosts_error = 18;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastHostHostsError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastHostHostsError = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastHostHostsError = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastHostHostsError = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool redirect_mode_broadcast_host_all_error = 19;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastHostAllError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastHostAllError = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastHostAllError = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastHostAllError = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_response_error = 20;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastTypeResponseError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastTypeResponseError = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastTypeResponseError = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastTypeResponseError = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional bool redirect_mode_broadcast_type_request_error = 21;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getRedirectModeBroadcastTypeRequestError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setRedirectModeBroadcastTypeRequestError = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearRedirectModeBroadcastTypeRequestError = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasRedirectModeBroadcastTypeRequestError = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool masquerade_egress_error = 22;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getMasqueradeEgressError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setMasqueradeEgressError = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearMasqueradeEgressError = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasMasqueradeEgressError = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool scanner_enable_scan_mdns_error = 23;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getScannerEnableScanMdnsError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setScannerEnableScanMdnsError = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearScannerEnableScanMdnsError = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasScannerEnableScanMdnsError = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool scanner_enable_scan_nbios_error = 24;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getScannerEnableScanNbiosError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setScannerEnableScanNbiosError = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearScannerEnableScanNbiosError = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasScannerEnableScanNbiosError = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool scanner_enable_scan_nmap_error = 25;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getScannerEnableScanNmapError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setScannerEnableScanNmapError = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearScannerEnableScanNmapError = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasScannerEnableScanNmapError = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool scanner_enable_scan_rdns_error = 26;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getScannerEnableScanRdnsError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setScannerEnableScanRdnsError = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearScannerEnableScanRdnsError = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasScannerEnableScanRdnsError = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool scanner_enable_scan_upnp_error = 27;
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.getScannerEnableScanUpnpError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.setScannerEnableScanUpnpError = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.UpdatePangolinResponse} returns this
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.clearScannerEnableScanUpnpError = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.UpdatePangolinResponse.prototype.hasScannerEnableScanUpnpError = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.PangolinSupportCheckRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.PangolinSupportCheckRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.PangolinSupportCheckRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinSupportCheckRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    until: (f = msg.getUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.PangolinSupportCheckRequest}
 */
proto.accounts.protos.PangolinSupportCheckRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.PangolinSupportCheckRequest;
  return proto.accounts.protos.PangolinSupportCheckRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.PangolinSupportCheckRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.PangolinSupportCheckRequest}
 */
proto.accounts.protos.PangolinSupportCheckRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.PangolinSupportCheckRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.PangolinSupportCheckRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.PangolinSupportCheckRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinSupportCheckRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUntil();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * required google.protobuf.Timestamp until = 1;
 * @return {!proto.google.protobuf.Timestamp}
 */
proto.accounts.protos.PangolinSupportCheckRequest.prototype.getUntil = function() {
  return /** @type{!proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1, 1));
};


/**
 * @param {!proto.google.protobuf.Timestamp} value
 * @return {!proto.accounts.protos.PangolinSupportCheckRequest} returns this
*/
proto.accounts.protos.PangolinSupportCheckRequest.prototype.setUntil = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinSupportCheckRequest} returns this
 */
proto.accounts.protos.PangolinSupportCheckRequest.prototype.clearUntil = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinSupportCheckRequest.prototype.hasUntil = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.PangolinSupportEnableRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.PangolinSupportEnableRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinSupportEnableRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    password: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.PangolinSupportEnableRequest}
 */
proto.accounts.protos.PangolinSupportEnableRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.PangolinSupportEnableRequest;
  return proto.accounts.protos.PangolinSupportEnableRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.PangolinSupportEnableRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.PangolinSupportEnableRequest}
 */
proto.accounts.protos.PangolinSupportEnableRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.PangolinSupportEnableRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.PangolinSupportEnableRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.PangolinSupportEnableRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * required string password = 1;
 * @return {string}
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accounts.protos.PangolinSupportEnableRequest} returns this
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.PangolinSupportEnableRequest} returns this
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.PangolinSupportEnableRequest.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accounts.protos.GenericPangolinResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accounts.protos.GenericPangolinResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accounts.protos.GenericPangolinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.GenericPangolinResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    statusCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    pangolinsList: jspb.Message.toObjectList(msg.getPangolinsList(),
    accounts_protos_pangolin_dto_pb.PangolinDTO.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accounts.protos.GenericPangolinResponse}
 */
proto.accounts.protos.GenericPangolinResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accounts.protos.GenericPangolinResponse;
  return proto.accounts.protos.GenericPangolinResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accounts.protos.GenericPangolinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accounts.protos.GenericPangolinResponse}
 */
proto.accounts.protos.GenericPangolinResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatusCode(value);
      break;
    case 2:
      var value = new accounts_protos_pangolin_dto_pb.PangolinDTO;
      reader.readMessage(value,accounts_protos_pangolin_dto_pb.PangolinDTO.deserializeBinaryFromReader);
      msg.addPangolins(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accounts.protos.GenericPangolinResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accounts.protos.GenericPangolinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accounts.protos.GenericPangolinResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPangolinsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      accounts_protos_pangolin_dto_pb.PangolinDTO.serializeBinaryToWriter
    );
  }
};


/**
 * required uint32 status_code = 1;
 * @return {number}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.getStatusCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accounts.protos.GenericPangolinResponse} returns this
 */
proto.accounts.protos.GenericPangolinResponse.prototype.setStatusCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.accounts.protos.GenericPangolinResponse} returns this
 */
proto.accounts.protos.GenericPangolinResponse.prototype.clearStatusCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.hasStatusCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated PangolinDTO pangolins = 2;
 * @return {!Array<!proto.accounts.protos.PangolinDTO>}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.getPangolinsList = function() {
  return /** @type{!Array<!proto.accounts.protos.PangolinDTO>} */ (
    jspb.Message.getRepeatedWrapperField(this, accounts_protos_pangolin_dto_pb.PangolinDTO, 2));
};


/**
 * @param {!Array<!proto.accounts.protos.PangolinDTO>} value
 * @return {!proto.accounts.protos.GenericPangolinResponse} returns this
*/
proto.accounts.protos.GenericPangolinResponse.prototype.setPangolinsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.accounts.protos.PangolinDTO=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accounts.protos.PangolinDTO}
 */
proto.accounts.protos.GenericPangolinResponse.prototype.addPangolins = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.accounts.protos.PangolinDTO, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accounts.protos.GenericPangolinResponse} returns this
 */
proto.accounts.protos.GenericPangolinResponse.prototype.clearPangolinsList = function() {
  return this.setPangolinsList([]);
};


goog.object.extend(exports, proto.accounts.protos);
